import {
    VALIDATION_ERRORS
} from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTableRow/hooks/useValidateImportFormTableRow";
import {
    removeErrorHeader
} from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTableRow/ValidateImportFormTableRow";
import {useImportContext} from "v4/pages/admin/Import/contexts/ImportContext";
import {useParams} from "react-router-dom";
import useToggle from "v4/hooks/useToggle";

export default function useValidateImportFormTable(tableHeaders) {
    const {importId} = useParams();
    const {nextStep} = useImportContext();
    const [isOpen, toggleIsOpen] = useToggle();
    const theadData = [{key: VALIDATION_ERRORS, label: '&zwj;'}, ...removeErrorHeader(tableHeaders)];

    const startImport = () => {
        toggleIsOpen(false);
        nextStep(importId);
    }

    return {
        theadData,
        startImport,
        isOpen,
        toggleIsOpen,
    }
}
